import type { DeleteModalProps } from 'src/common/DeleteModal';
import { DeleteModal } from 'src/common/DeleteModal';

export const TripRejectRequestModal = ({
  props,
}: {
  props: DeleteModalProps;
}) => {
  return <DeleteModal {...props} />;
};
